/**
 * App Store / Google Play badge buttons for the invite mobile chooser.
 */

type BadgeLinkProps = {
  href: string
  className?: string
}

export function AppStoreBadgeLink({ href, className }: BadgeLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Download on the App Store"
      data-testid="apply-app-store-badge"
    >
      <span className="flex items-center gap-3 rounded-xl bg-black px-5 py-3 text-white shadow-md transition hover:bg-neutral-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
        <svg viewBox="0 0 24 24" className="h-8 w-8 shrink-0 fill-current" aria-hidden>
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.22-1.98 1.08-3.13-1.05.04-2.31.7-3.06 1.58-.67.78-1.25 2.05-1.1 3.25 1.16.09 2.35-.66 3.08-1.7" />
        </svg>
        <span className="flex flex-col items-start leading-tight">
          <span className="text-[10px] font-medium uppercase tracking-wide text-neutral-300">
            Download on the
          </span>
          <span className="text-lg font-semibold tracking-tight">App Store</span>
        </span>
      </span>
    </a>
  )
}

/** Standard Google Play triangle mark (four-color). */
function GooglePlayIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-8 w-8 shrink-0" aria-hidden>
      <path fill="#00F076" d="M12.94 12 3.27 21.67a1.55 1.55 0 0 0 1.55.1l11.18-6.45L12.94 12z" />
      <path fill="#00D3FF" d="M20.54 10.56 16 7.94l-3.06 4.06 3.06 4.06 4.54-2.62a1.55 1.55 0 0 0 0-2.88z" />
      <path fill="#FFCE00" d="M3.27 2.33 12.94 12l3.06-4.06L4.82 1.49a1.55 1.55 0 0 0-1.55.1z" />
      <path fill="#FF3A44" d="M3.27 2.33A1.55 1.55 0 0 0 2.5 3.6v16.8a1.55 1.55 0 0 0 .77 1.27L12.94 12 3.27 2.33z" />
    </svg>
  )
}

export function GooglePlayBadgeLink({ href, className }: BadgeLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Get it on Google Play"
      data-testid="apply-play-store-badge"
    >
      <span className="flex items-center gap-3 rounded-xl bg-black px-5 py-3 text-white shadow-md transition hover:bg-neutral-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
        <GooglePlayIcon />
        <span className="flex flex-col items-start leading-tight">
          <span className="text-[10px] font-medium uppercase tracking-wide text-neutral-300">
            Get it on
          </span>
          <span className="text-lg font-semibold tracking-tight">Google Play</span>
        </span>
      </span>
    </a>
  )
}
